import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import { ApiError } from '../api/client.ts';
import { ErrorAlert } from './ErrorAlert.tsx';

/**
 * Estado a mostrar cuando una petición falla dentro de una pantalla.
 *
 * El caso que justifica que esto exista es el **404 de privacidad**: el backend
 * responde 404 —no 403— a una liga de la que no eres miembro o a un pronóstico ajeno
 * antes del kickoff, para no confirmar siquiera que existen (ADR 0004 y 0006).
 *
 * Un "Error 404" genérico sería una mala respuesta a eso por dos motivos: parece que la
 * aplicación se ha roto, y sobre todo invita a interpretar el resultado. El texto dice
 * explícitamente que no se puede distinguir entre "no existe" y "no es para ti", que es
 * justo lo que el servidor quiere que pase.
 */
export function ApiErrorState({ error }: { error: unknown }) {
  const { t } = useTranslation();
  if (!error) return null;

  if (error instanceof ApiError && error.isRestricted) {
    return (
      <section className="tarjeta" role="status" data-test="estado-restringido">
        <h2 className="mb-1 text-lg font-bold">{t('errors.restricted.title')}</h2>
        <p className="mb-3 text-sm text-tenue">{t('errors.restricted.body')}</p>
        <Link to="/" className="text-acento">
          {t('errors.restricted.back')}
        </Link>
      </section>
    );
  }

  return <ErrorAlert error={error} />;
}
